import { computed, watch, WatchHandle } from 'vue'

import { useStoreConferenceMediaStatuses } from '@/entities/conference-participant'
import { RTCSessionFacade, eventBus } from '@/entities/webrtc'

import { deactivateLocalVideoStream, activateUserMediaStream } from '..'

export const useDeactivateLocalWebCamStream = (facade: RTCSessionFacade) => {
  const { getParticipantMediaStatus } = useStoreConferenceMediaStatuses()

  const { callId, localVideoStream } = facade
  const callIdFromFacade = callId.value
  const statuses = computed(() => getParticipantMediaStatus(callIdFromFacade))

  let unwatch: WatchHandle
  const init = () => {
    unwatch = watch(() => statuses.value?.isVideoMuted, (n, o) => {
      if (n && !o) {
        deactivateLocalVideoStream(localVideoStream, facade.session.connection)
      } else if (!n && o && !localVideoStream.value) {
        activateUserMediaStream(facade.session, localVideoStream, 'video')
      }
    })
  }

  const destroy = () => unwatch?.()

  eventBus.on('callEnded', (callId: string) => {
    if (callId === callIdFromFacade) {
      destroy()
    }
  })

  return {
    init,
  }
}
